export const METADATA_FIELDS = ['amount', 'path']
